const arrowsBetweenStrings = {
    fallback: '[NO NAME]'
};

export default arrowsBetweenStrings;